import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { GameService } from '../../services/game.service';
import { GameMultipleChoiceQuestion, GameMultipleChoice, GameMultipleChoiceQuestionOption } from '../../_models/model';
import { ActivatedRoute, Router } from '@angular/router';
import { AudioPlayerService } from '../../services/audio-player.service';
import { IProgressBarOption } from '../../sharedComponents/progress-bar/progress-bar.component';
import { IGameComponent } from '../game/game.component';

@Component({
  selector: 'app-game-questions',
  templateUrl: './game-questions.component.html',
  styleUrls: ['./game-questions.component.less']
})
export class GameQuestionsComponent implements OnInit, IGameComponent {
  @Output() closeEvent = new EventEmitter<boolean>();
  private activeGame?: GameMultipleChoice;
  private activeLevelId?: number;
  private activeQuestion?: GameMultipleChoiceQuestion;

  // TODO: store progress data to send for levelProgress object
  private progressData = '';

  // Bindable properties
  public activeQuestionNr = 0;
  public questionText?: string;
  public options: GameMultipleChoiceQuestionOption[] = [];
  public feedbackText?: string;
  public showFootnote = false;
  public showResults = false;
  public buttonCaption = this.audio.text.global.next;
  public showMirror = false;
  public showAnswers = false;
  public hideOptions = false;
  public disableOptions = false;
  public enableNext = false;
  public enableMidNext = false;
  public mirrorText: string = '';
  public didYouReallyDoItPlayed: boolean = false;
  public showMirrorText = false;

  // Used to indicate the progress
  public progressBarData: IProgressBarOption[] = [];

  constructor(
    private gameService: GameService,
    private router: Router,
    private route: ActivatedRoute,
    public audio: AudioPlayerService,
    private _changeDetectionRef: ChangeDetectorRef) {

  }

  public setGame(game: GameMultipleChoice) {
    this.activeGame = game;
    this.activeQuestionNr = 0;
    this.activeQuestion = game.questions[0];

    // Used to indicate the progress
    for (let questionId = 0; questionId < this.activeGame.questions.length; questionId++) {
      this.progressBarData.push({ id: questionId, open: true, state: null });
    }
    this.showQuestion();
  }

  getProgressBarItem(questionNr: number): IProgressBarOption {
    const option = this.progressBarData.find(o => o.id === questionNr)
    if (option === undefined) {
      throw Error('option not found');
    }
    return option;
  }

  selectAnswer(answer: GameMultipleChoiceQuestionOption) {
    this.audio.stop();

    if (answer.correct !== true) {
      this.audio.playError();
      return;
    } else {
      this.audio.playSuccess();
    }

    this.enableNext = false;
    this.showFootnote = true;
    this.showResults = true;

    if (!this.activeQuestion) {
      throw Error('no active question found');
    }

    this.getProgressBarItem(this.activeQuestionNr).open  = false;
    this.getProgressBarItem(this.activeQuestionNr).state = 'done';

    // Play feedback
    this.audio.playAudio(this.activeQuestion.feedback, () => {
      this.enableNext = true;
    });
    setTimeout(() => {
      this.enableNext = true;
    }, 1000);
  }



  setNextQuestion() {
    if (!this.activeQuestion) {
      throw Error('no active question found');
    }

    if (!this.activeGame) {
      throw Error('no active game found');
    }
    this.getProgressBarItem(this.activeQuestionNr).open = false;
    this.getProgressBarItem(this.activeQuestionNr).state = 'done';

    if (this.enableMidNext) {
      this.audio.playAudio(this.activeQuestion.feedback);
      this.enableMidNext = false;
      this.showResults = true;
      return;
    }

    if (this.activeQuestionNr + 1 >= this.activeGame.questions.length) {
      this.gameService.setLevelProgress(this.activeGame.levelElement.uuid, this.progressData, true);
      this.closeEvent.emit();
      return;
    }

    this.activeQuestionNr++;
    this.showFootnote = false;
    this.showResults = false;
    this.showQuestion();
  }

  showQuestion() {
    if (!this.activeGame) {
      throw Error('no active game found');
    }
    this.audio.stop();
    this.activeQuestion = this.activeGame.questions[this.activeQuestionNr];
    this.questionText = this.activeQuestion.question.text;
    this.feedbackText = this.activeQuestion.feedback.text;
    this.options = this.activeQuestion.options;
    this.enableNext = false;

    // If question without answers
    if (this.activeQuestion.delay) {
      this.showMirror = true;
      this.buttonCaption = this.audio.text.global.done;
      this.disableOptions = true;
      this.audio.playAudio(this.activeQuestion.question);

      setTimeout(() => {
        this.showFootnote = true;
        this.showResults = false;
        this.showMirrorText = true;
        this.mirrorText = this.audio.getPlay('multiple_choice_mirror_text', () => {
          this.enableNext = true;
          this.enableMidNext = true;
        });
      }, 1000 * (Math.min(this.activeQuestion.delay, 5)));
    } else {
      this.showMirror = false;
      this.buttonCaption = this.audio.text.global.next;
      this.showFootnote = false;
      this.showResults = false;
      this.hideOptions = false;
      this.disableOptions = true;
      this.handleFootnote();
    }

    // tslint:disable-next-line:max-line-length
    // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4
    this._changeDetectionRef.detectChanges();
  }

  ngOnInit(): void {

  }

  private handleFootnote() {
    if (!this.activeQuestion) {
      throw Error('no active question found');
    }
    this.audio.playAudio(this.activeQuestion.question, x => {
      this.hideOptions = false;
      this.disableOptions = false;

    });
    setTimeout(() => {
      this.disableOptions = false;
    }, 1000);

  }
}
